import React, { useState, useEffect, useContext } from 'react';
import Card from '../card.component';
import Modal from '../modal/modal.component';
import {
    Col,
    Row,
} from 'react-bootstrap';
import { ConfigContextUtils } from '../../context/contextUtils.context';
import notification from '../notification.component';
import connect from '../../views/axios/axios.auth';


export const RecipientEdit = ({ data = null, onUpdate, onClose }) => {

    const { setPreloader } = useContext(ConfigContextUtils);
    const [visible, setVisible] = useState(false);
    const [inputValues, setInputValues] = useState({
        cliente_receptor_identificacion: '',
        cliente_receptor_telefono: '',
        cliente_receptor_nombre: '',
    })

    useEffect(() => {
        if (data !== null) {
            setVisible(true);
            setInputValues({
                cliente_receptor_identificacion: data.cliente_receptor_identificacion,
                cliente_receptor_telefono: data.cliente_receptor_telefono,
                cliente_receptor_nombre: data.cliente_receptor_nombre,
            });
        }
    },[data])

    const changeText = (ev) => {
        setInputValues({
            ...inputValues,
            [ev.target.name]: ev.target.value,
        })
    }


    const confirmupdate = () => {
        
        let isValid = true;

        if (inputValues.cliente_receptor_identificacion.trim() === '') {
          isValid = false;
        }

        if (inputValues.cliente_receptor_telefono.trim() === '') {
          isValid = false;
        }

        if (inputValues.cliente_receptor_nombre.trim() === '') {
          isValid = false;
        }

        if (!isValid) {
          notification.warning('Complete todos los campos requeridos');
        } else {
          
          const payload = {
            ...inputValues,
            recipient_id: data.id,
          }

          setPreloader(true); 

          connect.post('/cliente/destinatario-edit/', payload).then((response) => {
              if (response.data.error) {
                notification.warning(response.data.message);
              } else {
                notification.success(response.data.message);
                onUpdate(true);
                setVisible(false);
              }
              setPreloader(false);
          });

        }
    }

    const closeModal = () => {
        onClose();
        setVisible(false)
    }


    return (
        <Modal show={visible}>
            <Card>
            {data !== null ?
                <>
                <Row>
                    <Col>
                      <h3 className="title-card">Editar destinatario</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <small>Identificación</small>
                        <input type="text"
                            className={`form-control input-border`}
                            name="cliente_receptor_identificacion"
                            defaultValue={data.cliente_receptor_identificacion}
                            onChange={changeText}
                        />
                    </Col>
                    <Col>
                        <small>Telefono</small>
                        <input type="text"
                            className={`form-control input-border`}
                            name="cliente_receptor_telefono"
                            defaultValue={data.cliente_receptor_telefono}
                            onChange={changeText}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <small>Nombre completo</small>
                        <input type="text"
                            className={`form-control input-border`}
                            name="cliente_receptor_nombre"
                            defaultValue={data.cliente_receptor_nombre}
                            onChange={changeText}
                        />
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <button 
                            onClick={closeModal}
                            type="button"
                            className="btnx btnx-warn mr-1"
                            >
                                Cerrar
                        </button>
                        <button 
                            onClick={confirmupdate}
                            type="button"
                            className="btnx btnx-warn mr-1"
                            >
                                Confirmar
                        </button>
                    </Col>
                </Row>
                </>
            : null}
            </Card>
        </Modal>
    )
}
